import { useWatchConfigTables } from 'features/hmi/contexts/WatchConfigTablesContext';
import { useWatchSocketData } from 'features/hmi/contexts/WatchSocketContext';
import { hasInitialWatchData } from 'greener-ui-library';

export const useHasInitialWatchData = (): boolean => {
  const { messages } = useWatchSocketData();
  const configTables = useWatchConfigTables();

  return hasInitialWatchData(messages, configTables);
};
